/* Shipping protection toggle (snippets/palim-protection.liquid). Loaded site-wide from palim-style, because the
   drawer only renders the toggle once the cart has products. */
class PalimProtection extends HTMLElement {
  connectedCallback() {
    this.input = this.querySelector('input');
    this.input?.addEventListener('change', () => this.set(this.input.checked ? 1 : 0));
    const qty = Number(this.dataset.qty);
    const real = Number(this.dataset.real);
    if (qty > 0 && real === 0) this.set(0);
    else if (qty > 1) this.set(1);
  }

  async set(quantity) {
    if (this.busy) return;
    this.busy = true;
    this.setAttribute('aria-busy', 'true');
    const cart = document.querySelector('mini-cart');
    const onCartPage = /\/cart\/?$/.test(window.location.pathname);
    const body = { updates: { [this.dataset.variant]: quantity } };
    if (cart && !onCartPage) {
      body.sections = cart.getSectionsToRender().map((section) => section.id);
      body.sections_url = window.location.pathname;
    }
    try {
      const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/update.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body),
      });
      if (!response.ok) throw new Error('Could not update the cart');
      const data = await response.json();
      if (onCartPage) window.location.reload();
      else if (cart) cart.renderContents(data);
    } catch (error) {
      console.error(error);
      if (this.input) this.input.checked = !this.input.checked;
    } finally {
      this.busy = false;
      this.removeAttribute('aria-busy');
    }
  }
}

if (!customElements.get('palim-protection')) customElements.define('palim-protection', PalimProtection);
